var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelationshipsOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_3315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2072 19.1685H25.2264C25.2264 17.2827 23.9208 15.7504 22.316 15.7504H20.6659M5.33415 15.7504H3.68402C2.07922 15.7504 0.773621 17.2827 0.773621 19.1685H3.79282M17.148 8.15253C17.148 10.4464 15.2894 12.3051 12.9955 12.3051C10.7016 12.3051 8.84295 10.4464 8.84295 8.15253C8.84295 5.85867 10.7107 4 13.0046 4C15.2984 4 17.1571 5.85867 17.1571 8.15253H17.148ZM19.451 21C19.451 17.7995 17.3656 15.2064 14.8088 15.2064H11.1912C8.63442 15.2064 6.54909 17.8085 6.54909 21H19.46H19.451ZM23.8392 11.0176C23.8392 12.3685 22.7422 13.4656 21.3912 13.4656C20.0403 13.4656 18.9432 12.3685 18.9432 11.0176C18.9432 9.66667 20.0403 8.5696 21.3912 8.5696C22.7422 8.5696 23.8392 9.66667 23.8392 11.0176ZM4.61789 8.5696C5.96882 8.5696 7.06589 9.66667 7.06589 11.0176C7.06589 12.3685 5.96882 13.4656 4.61789 13.4656C3.26695 13.4656 2.16989 12.3685 2.16989 11.0176C2.16989 9.66667 3.26695 8.5696 4.61789 8.5696Z",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_3315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationshipsOff);
export default __webpack_public_path__ + "static/media/relationshipsOff.27c0275dcd1d51aa3ce53086321c12d7.svg";
export { ForwardRef as ReactComponent };